import { type ReactNode } from 'react';
import { ModalContainer } from './ModalContainer';
import { ModalContent } from './ModalContent';

interface ModalBasicProps {
  children?: ReactNode;
  disablePortal?: boolean;
  isOpen: boolean;
  onClose: () => void;
  scrollableContent?: boolean;
  subtitle?: string;
  className?: string;
  titleClassName?: string;
  hideCloseButton?: boolean;
}
interface ModalTitleProps {
  ariaLabel?: never;
  title: string;
}
interface ModalAriaLabelProps {
  ariaLabel: string;
  title?: never;
}

export type ModalProps = ModalBasicProps &
  (ModalTitleProps | ModalAriaLabelProps);

export const Modal = ({
  ariaLabel,
  children,
  disablePortal,
  isOpen,
  onClose,
  scrollableContent = true,
  subtitle,
  title,
  className,
  titleClassName,
  hideCloseButton = false,
}: ModalProps) => (
  <ModalContainer
    disablePortal={disablePortal}
    isOpen={isOpen}
    onClose={onClose}
  >
    <ModalContent
      ariaLabel={ariaLabel}
      onClose={onClose}
      scrollableContent={scrollableContent}
      subtitle={subtitle}
      title={title}
      className={className}
      titleClassName={titleClassName}
      hideCloseButton={hideCloseButton}
    >
      {children}
    </ModalContent>
  </ModalContainer>
);
